import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { ModuleDataHandler } from '../helpers/handleReportCalc';

interface IProps {
  moduleData: any;
  isView: boolean;
  item: any;
  numberOfDay: any;

  setRender: React.Dispatch<React.SetStateAction<boolean>>;
  index: number;
}

const paymentType: any = {
  co_roll: 'Co. Roll',
  regular: 'Regular',
};

const category_type: any = {
  staff: 'Staff',
  contractual: 'Contractual',
  operator: 'Operator',
};

const TBodyRow = ({
  moduleData,
  isView,
  item,
  index,
  numberOfDay,
  setRender,
}: IProps) => {
  const dataHandler = new ModuleDataHandler(moduleData, numberOfDay);
  return (
    <>
      <tr>
        <td>{index + 1}</td>
        <td>
          {typeof item?.emp_id !== 'string' && item?.emp_id?.employee_name}
        </td>
        <td>
          {typeof item?.emp_id !== 'string' &&
            paymentType[item?.emp_id?.payment_type]}
        </td>
        <td>
          {typeof item?.emp_id !== 'string' &&
            item?.emp_id?.department_id?.department_name}
        </td>
        <td>{typeof item?.emp_id !== 'string' && item?.emp_id?.designation}</td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.tot || null}
            onChange={(e) => {
              item.tot = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('tot', 'total_tot');
              dataHandler.calculateTotal('total_1', 'total_total_1');
              dataHandler.calculateTotal('amount', 'total_amount');
              dataHandler.calculateTotal('ot_amount', 'total_ot_amount');
              dataHandler.calculateTotal('total_2', 'total_total_2');
              dataHandler.calculateTotal('total_3', 'total_total_3');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.mobile || null}
            onChange={(e) => {
              item.mobile = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('mobile', 'total_mobile');
              dataHandler.calculateTotal('ot_amount', 'total_ot_amount');
              dataHandler.calculateTotal('total_2', 'total_total_2');
              dataHandler.calculateTotal('total_3', 'total_total_3');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.spl_allowance || null}
            onChange={(e) => {
              item.spl_allowance = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal(
                'spl_allowance',
                'total_spl_allowance'
              );
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput isView={true} type="number" value={numberOfDay || null} />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.p_day || null}
            onChange={(e) => {
              item.p_day = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('p_day', 'total_p_day');
              dataHandler.calculateTotal('total_1', 'total_total_1');
              dataHandler.calculateTotal('amount', 'total_amount');

              dataHandler.calculateTotal('ot_amount', 'total_ot_amount');
              dataHandler.calculateTotal('total_2', 'total_total_2');

              dataHandler.calculateTotal('total_3', 'total_total_3');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.l_day || null}
            onChange={(e) => {
              item.l_day = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('l_day', 'total_l_day');
              dataHandler.calculateTotal('total_1', 'total_total_1');
              dataHandler.calculateTotal('amount', 'total_amount');

              dataHandler.calculateTotal('ot_amount', 'total_ot_amount');
              dataHandler.calculateTotal('total_2', 'total_total_2');

              dataHandler.calculateTotal('total_3', 'total_total_3');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.total_1 || null}
          />
        </td>

        <td>
          <TableInput isView={true} type="number" value={item.amount || null} />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.ot_hr_s || null}
            onChange={(e) => {
              item.ot_hr_s = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('ot_hr_s', 'total_ot_hr_s');
              dataHandler.calculateTotal('ot_amount', 'total_ot_amount');
              dataHandler.calculateTotal('total_2', 'total_total_2');

              dataHandler.calculateTotal('total_3', 'total_total_3');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.ot_hr || null}
            onChange={(e) => {
              item.ot_hr = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('ot_hr', 'total_ot_hr');
              dataHandler.calculateTotal('ot_amount', 'total_ot_amount');
              dataHandler.calculateTotal('total_2', 'total_total_2');

              dataHandler.calculateTotal('total_3', 'total_total_3');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.ot_amount || null}
          />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.total_2 || null}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.pf || null}
            onChange={(e) => {
              item.pf = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('pf', 'total_pf');

              dataHandler.calculateTotal('total_3', 'total_total_3');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.esic || null}
            onChange={(e) => {
              item.esic = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('esic', 'total_esic');

              dataHandler.calculateTotal('total_3', 'total_total_3');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.labour || null}
            onChange={(e) => {
              item.labour = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('labour', 'total_labour');

              dataHandler.calculateTotal('total_3', 'total_total_3');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.total_3 || null}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.tea || null}
            onChange={(e) => {
              item.tea = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('tea', 'total_tea');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.adv || null}
            onChange={(e) => {
              item.adv = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('adv', 'total_adv');
              dataHandler.calculateTotal('payable', 'total_payable');
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.payable || null}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.cheque_payment || null}
            onChange={(e) => {
              item.cheque_payment = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal(
                'cheque_payment',
                'total_cheque_payment'
              );
              dataHandler.calculateTotal('cash_payable', 'total_cash_payable');
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.cash_payable || null}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="text"
            value={item.remarks || null}
            onChange={(e) => {
              item.remarks = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </td>
      </tr>
    </>
  );
};

export default TBodyRow;
